import React from 'react';
import classNames from 'classnames';
import { Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { IconChecked } from '../../../components';

import css from './PaymentMethodField.module.css';

const IconRadioButton = props => {
  const { className, checkedClassName, showAsRequired } = props;
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className={showAsRequired ? css.required : css.notChecked}
        cx="5"
        cy="19"
        r="6"
        transform="translate(2 -12)"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      />

      <g
        className={classNames(css.checked, checkedClassName || css.checkedStyle)}
        transform="translate(2 -12)"
        fill="none"
        fillRule="evenodd"
      >
        <circle strokeWidth="1" cx="5" cy="19" r="6" />
        <circle fill="#FFF" fillRule="nonzero" cx="5" cy="19" r="6" />
        <circle cx="5" cy="19" r="4" />
      </g>
    </svg>
  );
};

const PaymentMethodField = props => {
  const {
    className,
    isBestChoice,
    isSmartChoice,
    title,
    price,
    pricePer,
    descriptionList,
    planDescription,
    variant = 'vertical',
    id,
    ...rest
  } = props;

  const classes = classNames(css.root, className, {
    [css.horizontal]: variant === 'horizontal',
  });

  const radioButtonProps = {
    id,
    className: css.input,
    component: 'input',
    type: 'radio',
    ...rest,
  };

  const leftContent = (
    <>
      <div className={css.bestChoice}>
        {isBestChoice && <FormattedMessage id="General.bestChoice" />}
        {isSmartChoice && <FormattedMessage id="General.smartChoice" />}
      </div>
      <div className={css.title}>{title}</div>
      <div className={css.price}>
        {price}
        {pricePer && <span className={css.pricePer}>{pricePer}</span>}
      </div>
      <span className={css.radioButtonWrapper}>
        <IconRadioButton className={css.radioButtonSvg} />
      </span>
    </>
  );

  const rightContent = (
    <>
      {planDescription && <p className={css.planDescription}>{planDescription}</p>}
      <ul className={css.descriptionList}>
        {descriptionList.map(des => (
          <li key={des} className={css.descriptionItem}>
            <IconChecked />
            <span>
              {['max 10', 'to 10', 'onbeperkt', 'Unlimited'].some(str => des.includes(str)) ? (
                <strong>
                  {des} <sup>**</sup>
                </strong>
              ) : (
                des
              )}
            </span>
          </li>
        ))}
      </ul>
    </>
  );

  return (
    <div className={classes}>
      <Field {...radioButtonProps} />
      <label htmlFor={id} className={css.label}>
        {variant === 'horizontal' ? (
          <>
            <div className={css.left}>{leftContent}</div>
            <div className={css.right}>{rightContent}</div>
          </>
        ) : (
          <>
            {leftContent}
            {rightContent}
          </>
        )}
      </label>
    </div>
  );
};

export default PaymentMethodField;
